import React, { useContext } from "react";
import type { TypeDownshiftMergedInputProps } from "../types";
import {
  MenuTokenInput,
  type TypeMenuTokenInputProps,
} from "../MenuTokenInput";
import { useMenuToggleContext } from "../MenuContext";

export interface TypeAutocompleteTokenInputProps
  extends TypeDownshiftMergedInputProps<TypeMenuTokenInputProps> {}

export const AutocompleteTokenInput = ({
  onKeyDown,
  onChange,
  onInput,
  onBlur,
  onClick,
  inputProps,
  getTokenProps,
  ...rest
}: TypeAutocompleteTokenInputProps) => {
  const {
    getInputComponentProps,
    getDropdownProps,
    inputValue,
    isOpen,
    ref,
    ariaProps,
  } = useMenuToggleContext();

  return (
    <MenuTokenInput
      id="autocomplete_input"
      name="autocomplete_input"
      {...getInputComponentProps({
        ...(getDropdownProps?.({ ref, preventKeyAction: isOpen }) || { ref }),
        onKeyDown,
        onChange,
        onInput,
        onBlur,
        onClick,
        value: inputValue,
        refKey: "innerRef",
        inputProps,
        ...ariaProps,
      })}
      {...rest}
    />
  );
};
